import { RiErrorWarningFill } from 'react-icons/ri';

import styles from './notAuthorized.module.scss';

const NotAuthorized = () => {
	return (
		<div className={styles['wrapper']}>
			<div className={styles['message-wrapper']}>
				<RiErrorWarningFill className={styles['icon']} />
				<p className={styles['message']}>
					You do not have permission to access this resource.
				</p>
			</div>
		</div>
	);
};

export default NotAuthorized;
